import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API,
    headers: {
        'Content-Type': 'application/json'
    }
});

export default axiosInstance;
